<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> پیام مدیر </span>

    </div>

</div>

<main class=" rtl py-3 px-2">

    <span *ngIf="list_Message.length > 0"> تعداد <span class="text-danger fw-bold">{{list_Message.length | faNum}}</span> مورد یافت شد </span>

    <div class="row gx-2 mt-1 border border-2 ">

        <div class="col-12 col-md-10 p-2 p-md-3">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div class="col-12 col-md-2 p-2 p-md-3 d-flex align-items-center">

            <button class="btn mx-md-2 px-5 w-100 btn-primary" (click)="openModal('addMessage')"> افزودن </button>

        </div>

        <div class="table-responsive" style="max-height: 76vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <th>#</th>

                        <th>عملیات</th>

                        <th> عنوان </th>

                        <th> مدرسه </th>

                        <th> تاریخ </th>

                        <th> توضیحات </th>

                        <th> تعداد لایک </th>

                        <th> تعداد دیسلایک </th>

                        <th> تعداد کامنت </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Message;let i = index">

                        <th>{{ i + 1 | faNum }}</th>

                        <td class="col-1">

                            <i class="fa fa-microphone px-3 fa-lg  btn btn-primary" (click)="showMedia(item)"
                                title="صدا"></i>

                            <i class="fa fa-commenting-o fa-lg mt-2 btn btn-secondary" (click)="showComment(item)"
                                title="نظرات"></i>

                            <i class="fa fa-trash-o fa-lg mt-2 btn btn-danger" (click)="deleteMessage(item)"
                                title="حذف"></i>


                        </td>
                        
                        <td>{{item.strTitle}}</td>

                        <td>{{item.strMobileDomain_strComment}}</td>

                        <td>{{item.strDate | faNum}}</td>

                        <td>{{item.strComment}}</td>

                        <td>{{item.iLike | faNum}}</td>

                        <td>{{item.iDisLike | faNum}}</td>

                        <td>{{item.iComment | faNum}}</td>


                    </tr>

                </tbody>

            </table>

        </div>


    </div>

</main>

<!-- Modal -->


<div class="modal fade" id="comments" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> نظرات ( {{list_comments.length | faNum }} )</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body ">

                <div *ngFor="let item of list_comments" class="border border-2 rounded rtl w-100 row gx-2 p-2 mb-2"
                    style="max-height: 200px;overflow: auto;">

                    <span class="col-12 col-md-6"> نام و نام خانوادگی :
                        <strong>{{item.strPassenger_FullName}}</strong></span>

                    <span class="col-12 col-md-6 text-end mb-2"><strong>{{item.strFullDate | faNum}}</strong></span>

                    <p *ngIf="item.strComment != '' "> متن نظر : {{item.strComment | faNum}}</p>


                </div>

                <div *ngIf="list_comments.length == 0"> هنوز نظری ثبت نشده است </div>

            </div>

            <div class="modal-footer"></div>


        </div>

    </div>

</div>

<div class="modal fade" id="voice" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> صدای مدیر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body " *ngIf="audioManager != '' ">

                <audio controls class="w-100 rounded" style="background:#F1F3F4 ;">

                    <source src="data:audio/mp3;base64,{{audioManager}}" type="audio/mp3">

                    Your browser does not support the audio element.

                </audio>

            </div>

            <div class="modal-footer"></div>


        </div>

    </div>

</div>

<div class="modal fade" id="addMessage" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ثبت پیام جدید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="clearAudioRecordedData()"></button>

            </div>

            <div class="modal-body row gx-2 ">

                <div class="col-12">

                    <label class="text-danger"> عنوان </label>

                    <input type="text" [(ngModel)]="model.strTitle" name="strTitle" autocomplete="off" class="form-control" />

                </div>

                <!-- <div class="col-12 col-md-6 position-relative">

                    <label class="text-danger"> نام مدرسه </label>

                    <input type="search" ngModel name="selectedSchool" autocomplete="off" class="form-control" [(ngModel)]="searchT_School" (input)="filterSchool()" />

                    <ul class="list-group" style="max-height: 200px;overflow: auto;">

                        <li class="list-group-item pointer" *ngFor="let item of filteredSchools" [@fadeAnimation] (click)="model.iMobileDomain = item.iMobileDomain;filteredSchools=[];searchT_School=item.strComment"> {{ item.strComment }}</li>

                    </ul>

                </div> -->

                <div class="col-12 mt-3 position-relative">

                    <button class="btn btn-primary w-100 d-flex justify-content-center align-items-center "
                    
                        (click)="startAudioRecording()"

                        *ngIf="!isAudioRecording && !audioBlobUrl">

                        ضبط صدا

                        <i class="fa fa-microphone mx-2" aria-hidden="true"></i>

                    </button>

                    <button class="stop-button btn btn-warning w-100 d-flex justify-content-around "

                        *ngIf="isAudioRecording && !audioBlobUrl" (click)="stopAudioRecording()">

                        توقف ضبط

                        <div id="audioTimer" *ngIf="isAudioRecording && !audioBlobUrl">

                            {{ audioRecordedTime | faNum }}

                        </div>


                    </button>

                    <audio *ngIf="!isAudioRecording && audioBlobUrl" controls class="w-100">

                        <source [src]="audioBlobUrl" type="audio/mp3">
       
                    </audio>

                    <button *ngIf="audioBlobUrl != null" class="btn btn-danger audio-icon position-absolute" (click)="clearAudioRecordedData()"><i class="fa fa-trash fa-lg" aria-hidden="true"></i></button>

                </div>

                <div class="col-12 mt-3 text-end">

                    <button class="btn px-5  btn-success" (click)="newMessage()" > ذخیره </button>


                </div>

            </div>

            <div class="modal-footer"></div>


        </div>

    </div>

</div>

<ng-container *ngIf="isLoading">

    <div class="school_loading" style="z-index: 10000000088888888888888;">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>